import React, { useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import Sidebar from "../../../../partials/aside/Sidebar";
import httpService from "../../../../../services/httpServices/httpServices";
import helperNumber from "../../../../../helpers/numbers";
import helperSpinner from "../../../../../helpers/spinner";

function NativeInfoDeleted() {
  const params = useParams();
  const advertiseNativeDeletedID = params.id;
  useEffect(() => {
    getAdvertiseNativeDeletedUser(advertiseNativeDeletedID);
  }, []);

  const initAdvertiseNativeDeletedUser = {
    adv_active: null,
    adv_campaign_id: null,
    adv_confirm: null,
    adv_created_at: null,
    adv_deleted_at: null,
    adv_id: null,
    adv_type: null,
    adv_updated_at: null,
    adv_user_id: null,
    files: null,
    link: null,
  };

  const prefixLinkNativeAdvertise =
    process.env.REACT_APP_DOMAIN_API +
    "/" +
    process.env.REACT_APP_URL_ADVERTISE_FILES +
    "/native";

  const [advertiseNativeDeletedUser, setAdvertiseNativeDeletedUser] = useState(
    initAdvertiseNativeDeletedUser
  );
  const [advertiseNativeImage, setAdvertiseNativeImage] = useState(<></>);

  const getAdvertiseNativeDeletedUser = async (advertiseNativeDeletedID) => {
    helperSpinner.showSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);

    const advertiseNativeDeletedUser =
      await sendRequestGetAdvertiseNativeDeletedUser(advertiseNativeDeletedID);
    setAdvertiseNativeDeletedUser(advertiseNativeDeletedUser);

    const linkImage =
      prefixLinkNativeAdvertise + "/" + advertiseNativeDeletedUser.files;
    setAdvertiseNativeImage(<img src={linkImage} />);
    helperSpinner.removeSpinner(helperSpinner.CLASS_CONTENT_WRAPPER_TAG);
  };

  const sendRequestGetAdvertiseNativeDeletedUser = async (
    advertiseNativeDeletedID
  ) => {
    const headersRequest = getHeaderForRequest();
    let advertiseNativeDeletedUserInfo;
    try {
      advertiseNativeDeletedUserInfo = await httpService.getRequest(
        process.env.REACT_APP_DOMAIN_API +
          "/v1/advertise/manage/native/deleted/" +
          advertiseNativeDeletedID,
        headersRequest
      );
    } catch (error) {
      alert(error.response.data.message);
      return false;
    }

    return advertiseNativeDeletedUserInfo.data.data;
  };

  const getHeaderForRequest = () => {
    const token = localStorage.getItem("token");
    const headersRequest = {
      headers: {
        authorization: `Bearer ${token}`,
        "Content-Type": "application/json",
      },
    };

    return headersRequest;
  };

  let tagConfirm;
  if (advertiseNativeDeletedUser.adv_confirm != null) {
    let classNameConfirmAdvertise = "";
    let textConfirmAdvertise = "";
    switch (advertiseNativeDeletedUser.adv_confirm) {
      case 0:
        classNameConfirmAdvertise = "warning";
        textConfirmAdvertise = "در حال بررسی";
        break;
      case 1:
        classNameConfirmAdvertise = "success";
        textConfirmAdvertise = "تایید شده";
        break;
      case 2:
        classNameConfirmAdvertise = "danger";
        textConfirmAdvertise = "رد شده";
        break;
    }

    tagConfirm = (
      <span className={`badge badge-${classNameConfirmAdvertise}`}>
        {textConfirmAdvertise}
      </span>
    );
  }

  let tagActive;
  if (advertiseNativeDeletedUser.adv_active != null) {
    let classNameStateAdvertise = advertiseNativeDeletedUser.adv_active
      ? "success"
      : "danger";
    let textStateAdvertise = advertiseNativeDeletedUser.adv_active
      ? "فعال"
      : "غیر فعال";
    tagActive = (
      <span className={`badge badge-${classNameStateAdvertise} `}>
        {textStateAdvertise}
      </span>
    );
  }

  let nativesTag = [];
  if (advertiseNativeDeletedUser.files != null) {
    const native = advertiseNativeDeletedUser.files;

    Object.entries(native).map((native, index) => {
      const nativeSplit = native[0].split("-");
      const width = nativeSplit[0];
      const height = nativeSplit[1];
      nativesTag.push(
        <div key={index} className="mb-2  ">
          <div className="text-center font-weight-bold" dir="ltr">
            <span> </span>
            <span className="px-2">
              <span>{helperNumber.toPersianNum(width)}</span>
              <span className="px-2">*</span>
              <span>{helperNumber.toPersianNum(height)}</span>
            </span>
            <span></span>
          </div>
          <div className="position-relative">
            <a
              href={prefixLinkNativeAdvertise + "/" + native[1].file_name}
              target="_blank"
            >
              <img
                className="img-fluid"
                src={prefixLinkNativeAdvertise + "/" + native[1].file_name}
              />
            </a>
          </div>
        </div>
      );
    });
  }

  return (
    <>
      <Sidebar />

      <div className="content-wrapper">
        <section className="content-header pt-4  pb-0">
          <div className="container-fluid">
            <div className="row">
              <div className="w-100 text-center">
                <h1 className="px-5 py-1  bg-warning">
                  اطلاعات تبلیغ همسان حذف شده
                </h1>
              </div>
            </div>
          </div>
        </section>

        <section className="content">
          <div className="card">
            <div className="card-body">
              <div className="text-left">
                <Link
                  to="/advertise/manage/native/all/deleted"
                  className="btn btn-primary"
                >
                  <span className="pl-2">بازگشت</span>
                  <span>
                    <i className="fa fa-arrow-left"></i>
                  </span>
                </Link>
              </div>
              <div className="table-responsive pt-1">
                <table className="table table-bordered table-dark tbl-td-white-space table-hover">
                  <tbody>
                    <tr>
                      <td> شماره تبلیغ </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_id
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>شماره کاربری </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_user_id
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td>لینک</td>
                      <td>
                        <a
                          className="btn btn-primary"
                          target="_blank"
                          href={advertiseNativeDeletedUser.link}
                        >
                          <i class="fa fa-globe"></i>
                        </a>
                      </td>
                    </tr>
                    <tr>
                      <td> شماره کمپین </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_campaign_id
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td> وضعیت </td>
                      <td>{tagActive}</td>
                    </tr>
                    <tr>
                      <td> بررسی </td>
                      <td>{tagConfirm}</td>
                    </tr>
                    <tr>
                      <td> تاریخ ایجاد </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_created_at
                        )}
                      </td>
                    </tr>
                    <tr>
                      <td> تاریخ بروزرسانی </td>
                      <td>
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_updated_at
                        )}
                      </td>
                    </tr>

                    <tr>
                      <td> تاریخ حذف </td>
                      <td>
                        {" "}
                        {helperNumber.toPersianNum(
                          advertiseNativeDeletedUser.adv_deleted_at
                        )}
                      </td>
                    </tr>
                  </tbody>
                </table>

                <div
                  className="d-flex  flex-column align-items-center"
                  id="img-upload-native-container"
                >
                  {advertiseNativeImage}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default NativeInfoDeleted;
